export default {
  //Colores de la app
  colorPrm: "#2b2e83",
  colorSec: "#e94e1a",
  colorTrc: "#ef7643",
  colorGry: "#5F6868",
  colorGrn: "#27ae60",

  //Colores para Tiles
  lilaHdr: "#A569BD",
  lilaBdy: "#8E44AD",
  lilaFoo: "#7D3C98",
  blueHdr: "#5DADE2",
  blueBdy: "#3498DB",
  blueFoo: "#2E86C1",
  greenHdr: "#52BE80",
  greenBdy: "#27AE60",
  greenFoo: "#229954",
  orangeHdr: "#E59866",
  orangeBdy: "#DC7633",
  orangeFoo: "#D35400",
  yellowHdr: "#F4D03F",
  yellowBdy: "#F1C40F",
  yellowFoo: "#D4AC0D",
  redHdr: "#EC7063",
  redBdy: "#E74C3C",
  redFoo: "#CB4335",
  grapeHdr: "#7F8C8D",
  grapeBdy: "#707B7C",
  grapeFoo: "#616A6B",
  darkHdr: "#566573",
  darkBdy: "#2C3E50",
  darkFoo: "#273746",
  greyBdy: "#99A3A4",
  navyBdy: "#2AA9F5",
  brownBdy: "#900C3F",
  cyanBdy: "#7fe5dd",
};
